// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"c167a134","307":"1b63a2fa","444":"174fd9aa","453":"d48df938","467":"1d0aac25","883":"72255ca7","965":"d5a14559"}[chunkId] + ".chunk.js";
};